import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function WeeksSection() {
  const weeks = [{
    week: 'Semana 1',
    title: 'El Despertar',
    emoji: '🧠',
    desc: 'Reconoce tu conciencia como la única fuerza creadora.'
  }, {
    week: 'Semana 2',
    title: 'El Poder de la Imaginación',
    emoji: '🎭',
    desc: "Domina la técnica de 'vivir desde el final' para que la realidad no tenga más remedio que seguirte."
  }, {
    week: 'Semana 3',
    title: 'Revisión y Fe',
    emoji: '✍️',
    desc: 'El arte de reescribir tu pasado cada noche para liberar tu futuro.'
  }, {
    week: 'Semana 4',
    title: 'El Espejo de las Relaciones',
    emoji: '🪞',
    desc: "Entiende por qué 'todos son tú empujados hacia afuera' y cómo transformar a los demás cambiando tu concepto de ellos."
  }];
  return <div className="bg-white" data-id="element-136">
      <Section data-id="element-137">
        <div className="text-center mb-16" data-id="element-138">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-139">
            LO QUE VAS A DESCUBRIR DENTRO DEL EBOOK
          </h2>
          <div className="w-24 h-1 bg-sage mx-auto rounded-full" data-id="element-140" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-141">
          {weeks.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-cream p-8 rounded-xl border-l-4 border-sage shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-142">
              <div className="flex items-start gap-4" data-id="element-143">
                <span className="text-4xl" data-id="element-144">{item.emoji}</span>
                <div data-id="element-145">
                  <span className="text-sage-dark font-bold text-sm uppercase tracking-wider block mb-1" data-id="element-146">
                    {item.week}
                  </span>
                  <h3 className="text-xl font-bold text-navy mb-3 font-heading" data-id="element-147">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-148">{item.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </Section>
    </div>;
}